export const isShortTerm = (term) => term === 'short_term';
export const isLongTerm = (term) => term === 'long_term';
